// The connection-audit API returns wall-clock strings such as
// "2026-10-31 10:51:17" in the server's zone (Asia/Shanghai): the DB driver
// follows the host zone since 6bedab4. They carry no zone marker, so they are
// shown as they are. The older code read them as UTC and added 8 hours.
//
// A value that does carry an offset ("...Z", "...+08:00") is an exact instant
// and is converted to Asia/Shanghai.
export function formatAuditTime(s?: string | null): string {
  if (!s) return '';
  const text = s.trim().replace('T', ' ');
  if (/(Z|[+-]\d{2}:\d{2})$/.test(text)) {
    const d = new Date(text.replace(' ', 'T'));
    if (Number.isNaN(d.getTime())) return text;
    return d.toLocaleString('zh-CN', {
      timeZone: 'Asia/Shanghai',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  }
  const m = text.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}:\d{2}:\d{2})/);
  if (!m) return text;
  return `${m[1]}/${m[2]}/${m[3]} ${m[4]}`;
}
